import {
	captureCampaignFromRoute,
	refreshCampaignActivity
} from '~/composables/adCampaign/utils';
import { refreshLastSrpUrlActivity } from '~/composables/lastSrpUrl/utils';
import { refreshSessionActivity } from '~/composables/visitorIdentity/utils';

export default defineNuxtRouteMiddleware(to => {
	if (import.meta.client) {
		captureCampaignFromRoute(to);
		refreshCampaignActivity();
		refreshLastSrpUrlActivity();
		refreshSessionActivity();
	}
});
